module.exports = __webpack_public_path__ + "img/c-thermometer-img2-2.d30d5a67.png";